

//src/components/HeroSlider.js

import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  FaChevronLeft, FaChevronRight, FaBed, FaSwimmer,
  FaGlassCheers, FaTree, FaChevronDown,
} from "react-icons/fa";
import "../styles/HeroSlider.css";

const slides = [
  {
    image: "/images/Slider/02.jpg", // 👈 local image from public/images
    tag: "Welcome to USHA Resort",
    title: "A Serene Escape in the Heart of Patna",
    text: "Luxury rooms, a sparkling pool and lush green lawns — your perfect destination for stays, weddings and celebrations.",
  },
    {
    image: "/images/Slider/7.png", // 👈 local image from public/images
    tag: "Welcome to USHA Resort",
    title: "A Serene Escape in the Heart of Patna",
    text: "Luxury rooms, a sparkling pool and lush green lawns — your perfect destination for stays, weddings and celebrations.",
  },
  {
    image: "images/Slider/16.jpeg",
    tag: "Stay · Celebrate · Unwind",
    title: "Luxury Rooms & World-Class Amenities",
    text: "From elegant suites to a multi-cuisine restaurant, every moment at USHA Resort is crafted for your comfort.",
  },

  {
    image: "images/Slider/19.jpg",
    tag: "Weddings & Events",
    title: "Make Your Celebrations Truly Memorable",
    text: "Grand banquet halls and sprawling lawns — the most loved venue in Patna for weddings, receptions and parties.",
  },
    {
    image: "images/Slider/3.png",
    tag: "Weddings & Events",
    title: "Happy Moments, Happy Memories",
    text: "Grand banquet halls and sprawling lawns — the most loved venue in Patna for weddings, receptions and parties.",
  },
    {
    image: "images/Slider/11.png",
    tag: "Weddings & Events",
    title: "Happy Moments, Happy Memories",
    text: "Grand banquet halls and sprawling lawns — the most loved venue in Patna for weddings, receptions and parties.",
  },
    {
    image: "images/Slider/1.png",
    tag: "Weddings & Events",
    title: "Celebrate Life's Special Moments",
    text: "Grand banquet halls and sprawling lawns — the most loved venue in Patna for weddings, receptions and parties.",
  }
];


const features = [
  { icon: FaBed, label: "Luxury AC Rooms" },
  { icon: FaSwimmer, label: "Swimming Pool" },
  { icon: FaGlassCheers, label: "Banquet Hall" },
  { icon: FaTree, label: "Wedding Lawns" },
];

const HeroSlider = () => {
  const [index, setIndex] = useState(0);

  const next = useCallback(() => setIndex((i) => (i + 1) % slides.length), []);
  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(next, 6500);
    return () => clearInterval(timer);
  }, [next, index]);

  
  const Typewriter = ({ text }) => {
  const [shown, setShown] = useState("");
  useEffect(() => {
    setShown("");
    let i = 0;
    const t = setInterval(() => {
      i += 1;
      setShown(text.slice(0, i));
      if (i >= text.length) clearInterval(t);
    }, 90);
    return () => clearInterval(t);
  }, [text]);
  return <span className="hero-tag-animated type">{shown}<span className="type-cursor">|</span></span>;
};

  return (
    <section className="hero">
      {/* Background slides (images + overlay only) */}
      {slides.map((slide, i) => (
        <div key={i} className={`hero-slide ${i === index ? "active" : ""}`}>
          <img src={slide.image} alt={slides[index].title} />
          <div className="hero-overlay" />
        </div>
      ))}

      {/* 👇 Animated text — key={index} forces re-mount → animations replay every slide */}
      <div className="hero-content container" key={index}>
        {/* Letter-by-letter animated tag */}
        <span className="hero-tag-animated" aria-label={slides[index].tag}>
          {slides[index].tag.split("").map((char, i) => (
            <span key={i} style={{ animationDelay: `${0.15 + i * 0.05}s` }} aria-hidden="true">
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </span>

        {/* Word-by-word title with blur reveal */}
        <h1 className="hero-title-animated">
          {slides[index].title.split(" ").map((word, i) => (
            <span key={i} className="word" style={{ animationDelay: `${0.7 + i * 0.14}s` }}>
              {word}
            </span>
          ))}
        </h1>

        <p className="hero-text-animated">{slides[index].text}</p>

        <div className="hero-btns">
          <Link to="/rooms" className="btn btn-gold">Explore Rooms</Link>
          <Link to="/contact" className="btn btn-outline-white">Book Now</Link>
        </div>
      </div>

      {/* Feature highlights strip */}
      <div className="hero-features">
        {features.map(({ icon: Icon, label }) => (
          <div className="hero-feature" key={label}>
            <Icon />
            <span>{label}</span>
          </div>
        ))}
      </div>

      {/* Scroll-down indicator */}
      <a href="#welcome-scroll" className="hero-scroll" aria-label="Scroll down">
        <FaChevronDown />
      </a>

      <button className="hero-arrow left" onClick={prev} aria-label="Previous slide">
        <FaChevronLeft />
      </button>
      <button className="hero-arrow right" onClick={next} aria-label="Next slide">
        <FaChevronRight />
      </button>

      <div className="hero-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={i === index ? "active" : ""}
            onClick={() => setIndex(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
